import useSWRMutation from 'swr/mutation';
import {
  mfaConfirmRequest,
  mfaEnrollRequest,
  mfaPasskeyAuthOptionsRequest,
  mfaPasskeyAuthVerifyRequest,
  mfaPasskeyRegisterOptionsRequest,
  mfaPasskeyRegisterVerifyRequest,
  mfaRequestEmailCodeRequest,
  mfaVerifyRequest,
  type MfaCodeParams,
  type MfaEnrollParams,
  type MfaPasskeyVerifyParams,
  type MfaPendingParams,
} from '../requests';

export const useMfaEnrollMutation = () => {
  const { trigger, isMutating, error, reset } = useSWRMutation(
    'mfa-enroll-mutation',
    (_, { arg }: { arg: MfaEnrollParams }) => mfaEnrollRequest(arg),
  );

  return { enroll: trigger, isEnrolling: isMutating, enrollError: error, resetEnroll: reset };
};

export const useMfaConfirmMutation = () => {
  const { trigger, isMutating, error, reset } = useSWRMutation(
    'mfa-confirm-mutation',
    (_, { arg }: { arg: MfaCodeParams }) => mfaConfirmRequest(arg),
  );

  return { confirm: trigger, isConfirming: isMutating, confirmError: error, resetConfirm: reset };
};

export const useMfaVerifyMutation = () => {
  const { trigger, isMutating, error, reset } = useSWRMutation(
    'mfa-verify-mutation',
    (_, { arg }: { arg: MfaCodeParams }) => mfaVerifyRequest(arg),
  );

  return { verify: trigger, isVerifying: isMutating, verifyError: error, resetVerify: reset };
};

export const useMfaRequestEmailCodeMutation = () => {
  const { trigger, isMutating, error, reset } = useSWRMutation(
    'mfa-email-request-mutation',
    (_, { arg }: { arg: MfaPendingParams }) => mfaRequestEmailCodeRequest(arg),
  );

  return {
    requestEmailCode: trigger,
    isRequestingEmailCode: isMutating,
    requestEmailCodeError: error,
    resetRequestEmailCode: reset,
  };
};

export const useMfaPasskeyRegisterOptionsMutation = () => {
  const { trigger, isMutating, error, reset } = useSWRMutation(
    'mfa-passkey-register-options-mutation',
    (_, { arg }: { arg: MfaPendingParams }) => mfaPasskeyRegisterOptionsRequest(arg),
  );

  return {
    passkeyRegisterOptions: trigger,
    isRequestingRegisterOptions: isMutating,
    passkeyRegisterOptionsError: error,
    resetPasskeyRegisterOptions: reset,
  };
};

export const useMfaPasskeyRegisterVerifyMutation = () => {
  const { trigger, isMutating, error, reset } = useSWRMutation(
    'mfa-passkey-register-verify-mutation',
    (_, { arg }: { arg: MfaPasskeyVerifyParams }) => mfaPasskeyRegisterVerifyRequest(arg),
  );

  return {
    passkeyRegisterVerify: trigger,
    isVerifyingRegister: isMutating,
    passkeyRegisterVerifyError: error,
    resetPasskeyRegisterVerify: reset,
  };
};

export const useMfaPasskeyAuthOptionsMutation = () => {
  const { trigger, isMutating, error, reset } = useSWRMutation(
    'mfa-passkey-auth-options-mutation',
    (_, { arg }: { arg: MfaPendingParams }) => mfaPasskeyAuthOptionsRequest(arg),
  );

  return {
    passkeyAuthOptions: trigger,
    isRequestingAuthOptions: isMutating,
    passkeyAuthOptionsError: error,
    resetPasskeyAuthOptions: reset,
  };
};

export const useMfaPasskeyAuthVerifyMutation = () => {
  const { trigger, isMutating, error, reset } = useSWRMutation(
    'mfa-passkey-auth-verify-mutation',
    (_, { arg }: { arg: MfaPasskeyVerifyParams }) => mfaPasskeyAuthVerifyRequest(arg),
  );

  return {
    passkeyAuthVerify: trigger,
    isVerifyingAuth: isMutating,
    passkeyAuthVerifyError: error,
    resetPasskeyAuthVerify: reset,
  };
};
